/* eslint-disable storybook/default-exports */
import SearchView from './components/SearchView.vue';
import { frontendURL } from '../../helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/search'),
    name: 'search',
    roles: ['administrator', 'agent', 'seller', 'supervisor', 'team_supervisor', 'analyzer', 'assistant'],
    component: SearchView,
    accountTypes: ['account', 'subaccount', 'parent_account']
  },
];
